import { render, staticRenderFns } from "./editOrderVehiclePrice.vue?vue&type=template&id=41bfd088&scoped=true&"
import script from "./editOrderVehiclePrice.vue?vue&type=script&lang=js&"
export * from "./editOrderVehiclePrice.vue?vue&type=script&lang=js&"
import style0 from "./editOrderVehiclePrice.vue?vue&type=style&index=0&id=41bfd088&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bfd088",
  null
  
)

export default component.exports